import React from 'react';
import {THEMES} from './RootContainer';
import  PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

// constants

// radio server URL
const RADIO_URL         = "https://badradio.biz:8443";
const STREAM_ENDPOINT   = `${RADIO_URL}/stream`;
const AMBIENT_ENDPOINT  = `${RADIO_URL}/ambient`;
const STATUS_ENDPOINT   = `${RADIO_URL}/status-json.xsl`;

// Unproxied radio server URL
const UNPROXIED_RADIO_URL		= "http://server.badradio.biz:8000";
const UNPROXIED_STREAM_ENDPOINT  	= `${UNPROXIED_RADIO_URL}/stream`;
const UNPROXIED_AMBIENT_ENDPOINT  	= `${UNPROXIED_RADIO_URL}/ambient`;

// comment server URL
const BACKEND_URL               = "https://badradio.biz:5000";
const COMMENT_GET_ENDPOINT      = `${BACKEND_URL}/comments`;
const COMMENT_POST_ENDPOINT     = `${BACKEND_URL}/new`;
const CSRF_ENDPOINT             = `${BACKEND_URL}/csrf`;
const SESSION_CHECK_ENDPOINT    = `${BACKEND_URL}/checksessionstatus`;
const REGISTER_ENDPOINT         = `${BACKEND_URL}/registerphone`;

// polling intervals:
//  check every 5 seconds for stream status
//  check every 10 seconds to see if comments have been enabled
//  check every second for new comments if so
const STATUS_POLL_INTERVAL          = 5000;
const NULL_COMMENT_POLL_INTERVAL    = 10000;
const ACTIVE_COMMENT_POLL_INTERVAL  = 1000;

// display names for all the fields for current show
const FIELD_DISPLAYS = {
    server_name         : "STREAM NAME", 
    server_description  : "STREAM DESCRIPTION", 
    stream_start        : "STREAM STARTED", 
    genre               : "GENRE", 
    server_url          : "STREAM URL", 
    title               : "CURRENTLY PLAYING"
};

// marquee elements move at 48 pixels per second
const MARQUEE_PPS = 48;

// minimum pixel distance from bottom of screen to auto-scroll to newest comment
const COMMENT_AUTOSCROLL_THRESHOLD = 100;

const PHONENUMBERHELPTEXT = <p>
    In order to offer more protection to our DJs, Bad Radio is now requiring commenters to register with a valid phone number. Unfortunate, but that's how it goes. Things to know: <br/>
    <br/>
    ✿ We do NOT store your phone number on our servers (we store a SHA256 hash of it instead, if you're curious). <br/>
    <br/>
    ✿ No one can see the phone number you submit, not the DJ or your fellow commenters. <br/>
    <br/>
    ✿ We will text you exactly ONCE, with an auth code to confirm the number is yours. <br/>
    <br/>
    ✿ Once you authenticate, you'll be able to comment as usual and you won't have to provide the number again for 365 days. <br/>
    <br/>
    ✿ You can use the same number on a bunch of different browsers and computers. <br/>
    <br/>
    ✿ DJs CAN block you if you're acting rude so you gotta be nice now.
</p>;
   
class StreamContainer extends React.Component {
    // scheduled async functions

    // polls icecast server for current status
    pollStatus() {
        fetch(STATUS_ENDPOINT)
        // there are certain versions of Icecast that don't return valid JSON for certain song name inputs - huge issue! so this regex resolves it
        .then(response => response.text())
        .then(text => JSON.parse(text.replace(/([^\\])(["']): *- *,(["'])/g, "$1$2:\"-\",$3")))
        .then(streamInfoContainer => {
            let streamInfo = streamInfoContainer['icestats']['source'];
            let showPlaying = false;
            if (Array.isArray(streamInfo)) {
                let stream = streamInfo.find(element => ('listenurl' in element && element['listenurl'] === UNPROXIED_STREAM_ENDPOINT));
                if (stream && 'stream_start' in stream) {
                    streamInfo = stream;
                    showPlaying = true;
                } else {
                    let ambient = streamInfo.find(element => ('listenurl' in element && element['listenurl'] === UNPROXIED_AMBIENT_ENDPOINT));
                    if (ambient && 'stream_start' in ambient) {
                        streamInfo = ambient;
                    } else {
                        streamInfo = {};
                    }
                }
            }
            if (streamInfo !== this.state.streamInfo || showPlaying !== this.state.showPlaying) {
                this.setState({streamInfo: streamInfo, showPlaying: showPlaying});
            }
        }).catch(err => {
            console.error(`Error parsing status JSON! ${err}`);
        });
    }

    // polls comment endpoint and updates internal comments state element
    pollComments() {
        fetch(COMMENT_GET_ENDPOINT)
        .then(response => response.json())
        .then(comments => {
            // update polling intervals on comment state change
            if ((comments && !this.state.comments) || (!comments && this.state.comments)) {
                if (this.state.commentInterval) {
                    clearInterval(this.state.commentInterval);
                }
                this.setState({commentInterval: setInterval(this.pollComments.bind(this), (comments ? ACTIVE_COMMENT_POLL_INTERVAL : NULL_COMMENT_POLL_INTERVAL))});
            }
            if (comments !== this.state.comments) {
                this.setState({comments: comments});
            }
        });
    }

    // checks API to determine if user has valid session, needs to auth, or is blocked
    checkSession() {
        fetch(SESSION_CHECK_ENDPOINT, {credentials: "include"})
        .then(response => response.text())
        .then(text =>
            this.setState({
                validSession: text === "valid session",
                blocked: text === "number blocked"
            })
        );
    }

    getCSRFToken() {
        fetch(CSRF_ENDPOINT, {credentials: "include"})
        .then(response => response.text())
        .then(text => 
            this.setState({
                csrfToken: text
            })
        );
    }

    togglePlayState() {
        if (STREAM_ENDPOINT !== "") {
            // muting the audio stream instead of pausing it, so it
	    // stops getting choppy when resumed
            let paused = !(this.state.paused);
            this.player.muted = paused;
            if (this.state.paused && !paused) {
            	this.player.play();
	    }
            this.setState({paused: paused});
	    
            // if (this.state.paused) {
                // this.player.play();
            // } else {
                // this.player.pause();
                // this.player.load();
            // }
            // this.setState({paused: !(this.state.paused)});
        }
    }

    monitorPlayState() {
	// No more letting this thing get paused
        if (this.player.paused !== this.state.paused) {	
	    if (this.player.paused) {
	        this.player.play();
	    }
	    this.player.muted = paused;
            this.setState({paused: this.state.paused});
        }
    }

    // change volume (has no effect on mobile)
    iterateVolume() {
        let volume = (this.state.volume + 1) % 4;
        this.player.volume = volume / 3;
        // set state based on actual volume so that on platforms where volume can't be set 
        // (e.g. mobile browser) it doesn't display an improper value
        // although immediately after it's set, it seems to retain an inaccurate value before resetting itself
        // hence the quick timeout
        setTimeout(() => this.setState({volume: Math.round(this.player.volume * 3)}), 100);
    }

    handleFieldChange(fieldName, changeEvent) {
        this.setState({[fieldName]: changeEvent.target.value});
    }

    toggleHelpDisplay() {
        this.setState({helpDisplayed: !this.state.helpDisplayed});
    }

    // I need to set player size in a way that's not easily accomplished in pure CSS, so I register a callback with the parent on window resize
    handleWindowResize() {
        if (this.playButtonElem && this.playButtonElem.offsetHeight) {
            this.setState({playButtonWidth: `${this.playButtonElem.offsetHeight}px`});
        }
        if (this.volumeButtonElem && this.volumeButtonElem.offsetHeight) {
            this.setState({volumeButtonWidth: `${this.volumeButtonElem.offsetHeight}px`});
        }
        if (this.radioPlayerElem && this.playButtonElem && this.volumeButtonElem) {
            this.setState({radioStatusWidth: `${this.radioPlayerElem.offsetWidth - this.playButtonElem.offsetHeight - this.volumeButtonElem.offsetHeight - 30}px`});
        }
    }
    
    registerPhone(event) {
        if (event._reactName === "onClick" || event.keyCode === 13) {
            let body = ("phone_number=" + 
                encodeURIComponent(this.state.phoneNumber).replace(/[^\d]/, ""));
            if (this.state.enteringAuthCode) {
                body += `&auth_code=${encodeURIComponent(this.state.authCode)}`;
                this.setState({submittingComment: true});
            }
            fetch(REGISTER_ENDPOINT, {
                method: "POST",
                credentials: "include",
                headers:    {
                    'X-CSRFToken'   : this.state.csrfToken,
                    'Content-Type'  : "application/x-www-form-urlencoded"
                },
                body:   body
            }).then(response => response.text())
            .then(response => {
                if (this.state.enteringAuthCode) {
                    this.setState({
                        enteringAuthCode: false
                    });
                    if (response === "number registered") {
                        this.setState({
                            validSession: true
                        });
                    } else if (response === "number blocked") {
                        this.setState({
                            blocked: true
                        });
                    } else if (response === "invalid auth code") {
                        alert("invalid auth code");
                        this.setState({
                            enteringAuthCode: true
                        });
                    }
                    setTimeout(() => this.setState({submittingComment: false}), 500);
                } else { 
                    if (response === "auth code sent") {
                        this.setState({
                            enteringAuthCode: true
                        });
                    } else if (response === "number blocked") {
                        this.setState({
                            blocked: true
                        });
                    } else {
                        alert(response);
                    }
                }
            });
        }
    }

    submitComment(event) {
        if (event._reactName === "onClick" || event.keyCode === 13) {
            this.setState({submittingComment: true});
            fetch(COMMENT_POST_ENDPOINT, {
                method: "POST",
                credentials: "include",
                headers:    {
                    'X-CSRFToken'   : this.state.csrfToken,
                    'Content-Type'  : "application/x-www-form-urlencoded"
                },
                body:   `name=${encodeURIComponent(this.state.commentName)}&comment=${encodeURIComponent(this.state.commentText)}`
            }).then(response => response.text())
            .then(response => {
                if (response === "comment successfully added") {
                    this.setState({commentText: ""});
                    setTimeout(() => {
                        this.setState({submittingComment: false});
                        this.commentFieldElem.focus();
                    }, 500);
                } else if (response === "number blocked") {
                    this.setState({
                        validSession: false,
                        blocked: true
                    });
                } else if (response === "invalid session") {
                    this.setState({
                        validSession: false
                    });
                } else {
                    alert(response);
                }
            });
        }
    }

    // generic React element ref callback
    elementRefCallback(elementName, ref) {
        this[elementName] = ref;
    }

    constructor(props) {
        super(props);

        this.state = {
            paused:         true,
            volume:         3,

            streamInfo:     null,
            statusInterval: null,
            showPlaying:    false,

            comments:               null,
            commentInterval:        null,
            submittingComment:      false,
            enteringAuthCode:     false,
            lastAutoscrollHeight:   0,
            csrfToken:          "",

            helpDisplayed:      false,
            validSession:       false,
            blocked:            false,

            countryCode:        "+1",
            phoneNumber:        "",
            authCode:           "",

            commentName:        "",
            commentText:        "",

            playButtonWidth:    "0px",
            volumeButtonWidth:  "0px",
            radioStatusWidth:   "0px",

            statusAnimationDuration:    "0s"
        };

        props.registerResizeCallback(this.handleWindowResize.bind(this));
    }

    componentDidMount() {
        this.handleWindowResize();
        
        this.getCSRFToken();
        this.checkSession();

        this.pollStatus();
        if (COMMENT_GET_ENDPOINT !== "") {
            this.pollComments();
            this.setState({
                statusInterval:     setInterval(this.pollStatus.bind(this), STATUS_POLL_INTERVAL),
                commentInterval:    setInterval(this.pollComments.bind(this), NULL_COMMENT_POLL_INTERVAL)
            });
        }

        document.body.onkeyup = e => {
            if ((document.activeElement === null || document.activeElement === document.body) && e.keyCode === 32) {
                e.preventDefault();
                this.togglePlayState();
            }
        };
        Array.prototype.map.call(document.getElementsByClassName("form-control"), element => {
            element.autocomplete = "off";
        });
        
    }

    componentDidUpdate() {
        if ((this.playButtonElem && this.playButtonElem.offsetWidth !== this.playButtonElem.offsetHeight) || (this.volumeButtonElem && this.volumeButtonElem.offsetWidth !== this.volumeButtonElem.offsetHeight)) {
            this.handleWindowResize();
        }

        if (this.radioStatusElem) {
            let newAnimationDuration = `${this.radioStatusElem.offsetWidth / 2 / MARQUEE_PPS}s`;
            if (newAnimationDuration !== this.state.statusAnimationDuration) {
                this.setState({statusAnimationDuration: newAnimationDuration});
            }
        }

        // scroll latest comment into view if close and this comment hasn't been scrolled into view before
        if (this.commentContainerElem && this.commentParentElem && this.state.lastAutoscrollHeight !== this.commentParentElem.offsetHeight && this.commentContainerElem.scrollTop + this.commentContainerElem.offsetHeight >= this.commentParentElem.offsetHeight - COMMENT_AUTOSCROLL_THRESHOLD) {
            this.commentContainerElem.scrollTo({top: this.commentParentElem.offsetHeight - this.commentContainerElem.offsetHeight, behavior: "smooth"});
            this.setState({lastAutoscrollHeight: this.commentParentElem.offsetHeight});
        }
    }

    componentWillUnmount() {
        clearInterval(this.statusInterval);
        clearInterval(this.pollInterval);
        document.body.onkeyup = null;
    }
 
    render() {

        // standard status text transform for null values
        let substituteNull = field => field.replace("(null)", "None").replace("(?null)? - (?null)?", "-")

        // applies defined transform for each value in stream info
        // or if no transform is defined for the field, the standard null substitution
        let textReplacementFunctions = {
            stream_start    : stream_start => (stream_start.substring(0, Math.max(0, stream_start.length - 6))),
            server_url      : server_url => substituteNull(server_url) === "None" ? "None" : (<div className="linkdiv"><a className="dottedLink" href={substituteNull(server_url).replace(/^(?!https?:\/\/)(.*)$/g, "http://$1")} target="_blank" rel="noopener noreferrer">{substituteNull(server_url)}</a></div>)
        }
        let processField = (fieldName, fieldValue) => {
            return (fieldValue ?
                (fieldName in textReplacementFunctions ? textReplacementFunctions[fieldName] : substituteNull)(fieldValue)
                : "None"
            );
        }

        let fieldDisplayElems = Object.keys(FIELD_DISPLAYS).map(fieldKey => (
            <React.Fragment key={this.state.streamInfo ? `${fieldKey}:${this.state.streamInfo[fieldKey]}` : `${fieldKey}empty`}>
                <div className="streamstatnames statnames pixelfont"> 
                    {FIELD_DISPLAYS[fieldKey]}
                </div>
                <div className="streamstats stats">
                    {this.state.streamInfo ? processField(fieldKey, this.state.streamInfo[fieldKey]) : "LOADING..."}
                </div>
            </React.Fragment>
        ));

        // calls dangerouslySetInnerHTML on comment text that's first been sanitized with python bleach library and then parsed for <a> links
        let commentDisplayElems = this.state.comments ? Object.keys(this.state.comments).map(commentId => (
            <div id={`comment${commentId}`} className="commentrow" key={`${commentId}:${this.state.comments[commentId]['name']}:${this.state.comments[commentId]['comment']}`} ref={this.elementRefCallback.bind(this, 'latestCommentElem')}>
                <div className="commentnamecontainer">
                    <a className="commentname pixelfont">{this.state.comments[commentId]['name']}</a>
                </div>
                <div className="commenttextcontainer">
                    <a className="commenttext" dangerouslySetInnerHTML={{__html: this.state.comments[commentId]['comment']}} />
                </div>
            </div>
        )) : null;

        let radioStatusTextElem = null;
        if (this.state.showPlaying) {
            radioStatusTextElem = [];
            [...Array(8).keys()].map(index => radioStatusTextElem.push(<div className="innerstatus" key={`innerstatus${index}`}>Live Now: <span className="pixelfont">{this.state.streamInfo['server_name'].toUpperCase()}</span>{(this.state.streamInfo['title'] && !(substituteNull(this.state.streamInfo['title']) in ["None", "-"])) ? ` playing ${this.state.streamInfo['title']}` : null}</div>));
        } else {
            radioStatusTextElem = (this.state.streamInfo ? (this.state.streamInfo['server_name'] || "Stream Offline") : "LOADING...");
        }

        let themeBackgroundColor = Array.isArray(THEMES[this.props.theme][0]) ? THEMES[this.props.theme][0][1] : THEMES[this.props.theme][0];

        return (
            <div id="streaminfocontainer" style={this.props.style}>
                <div id="streamcontainer" className="borderbottom">
                    <audio id="radiostream" src={STREAM_ENDPOINT} ref={this.elementRefCallback.bind(this, 'player')}></audio> 
                    <div id="radioplayer" ref={this.elementRefCallback.bind(this, 'radioPlayerElem')}>
                        <div id="radioplay" style={{width: this.state.playButtonWidth}} onClick={this.togglePlayState.bind(this)} ref={this.elementRefCallback.bind(this, 'playButtonElem')}>
                            <img id="radioplayicon" alt="Radio Play Button" className="themeresponsiveimg" src={`img/${this.state.paused ? "play" : "pause"}-${this.props.theme}.png`} />
                        </div>
                        <div id="radiostatuscontainer" className={this.state.showPlaying ? "marqueecontainer" : "nonmarquee"} style={{width: this.state.radioStatusWidth, borderColor: THEMES[this.props.theme][1]}} ref={this.elementRefCallback.bind(this, 'statusContainerElem')}>
                            <div id="radiostatus" className={this.state.showPlaying ? "marquee" : null} style={{animationDuration: this.state.statusAnimationDuration}} ref={this.elementRefCallback.bind(this, 'radioStatusElem')}>
                                {radioStatusTextElem}
                            </div>
                        </div>
                        <div id="radiovolume" style={{width: this.state.volumeButtonWidth}} onClick={this.iterateVolume.bind(this)} ref={this.elementRefCallback.bind(this, 'volumeButtonElem')}>
                            <img id="radiovolumeicon" alt="Radio Volume Button" className="themeresponsiveimg" src={`img/volume-${this.state.volume}-${this.props.theme}.png`} />
                        </div>
                    </div>
                </div>
                <div id="infochatcontainer" className={this.state.comments ? null : "nocomments"}>
                    <div id="infocontainer" className={this.state.comments ? null : "nocomments"} key={this.state.comments ? "infocontainercomments" : "infocontainernocommments"} >
                        <div></div><div className="borderleft"></div>
                        {fieldDisplayElems}
                        <div></div><div className="borderleft"></div>
                    </div>
                    <div id="chatcontainer" className={this.state.comments ? null : "nocomments"}>
                        <div id="chatheader" className="borderbottom pixelfont">
                            {this.state.helpDisplayed ? "HELP" : "CHAT"}
                        </div>
                        <div id="commentcontainer" className="borderbottom" ref={this.elementRefCallback.bind(this, 'commentContainerElem')}>
                            {this.state.helpDisplayed ? (
                                <div id="helpparent">
                                    {PHONENUMBERHELPTEXT}
                                </div>
                            ) : (
                                <div id="commentparent" ref={this.elementRefCallback.bind(this, 'commentParentElem')}>
                                    {commentDisplayElems}
                                </div>
                            )}
                        </div>
                        {this.state.blocked ? (
                            <button id="blocked" className="pixelfont nonclickable" style={{backgroundColor: THEMES[this.props.theme][1], color: themeBackgroundColor}}>BLOCKED</button>
                        ) : (
                            <>{this.state.validSession ? (
                                <div id={this.state.submittingComment ? "submittingcommenteditor" : (this.state.enteringAuthCode ? "authcodeeditor" : "commenteditor")}>
                                    {this.state.submittingComment ? (
                                        <button id="commentsubmit" className="pixelfont nonclickable" style={{backgroundColor: THEMES[this.props.theme][1], color: themeBackgroundColor}}>SENDING...</button>
                                    ) : (
                                        <>
                                            <div id="nameinputcontainer" className="inputcontainer">
                                                <input type="text" id="namefield" name="namefield" className="input pixelfont" placeholder="NAME" onChange={this.handleFieldChange.bind(this, 'commentName')} value={this.state.commentName} />
                                            </div>
                                            <div className="inputcontainer borderleft">
                                                <input type="text" id="commentfield" name="commentfield" className="input tk-acumin-pro-wide" ref={this.elementRefCallback.bind(this, 'commentFieldElem')} onChange={this.handleFieldChange.bind(this, 'commentText')} value={this.state.commentText} onKeyUp={this.submitComment.bind(this)} />
                                            </div>
                                            <button id="commentsubmit" className="pixelfont" style={{backgroundColor: THEMES[this.props.theme][1], color: themeBackgroundColor}} onClick={this.submitComment.bind(this)}>SEND</button>
                                        </>)}
                                </div>
                            ) : (
                                <>{!(this.state.enteringAuthCode) ? (
                                    <div id="phonenumbereditor">
                                        <div className="labelcontainer">
                                            <div className="label pixelfont">PHONE NUMBER:</div>
                                        </div>
                                        <PhoneInput id="phoneinput" country={'us'} 
                                        value={this.state.phoneNumber} onChange={phoneNumber => this.setState({phoneNumber})}
                                        containerClass="inputcontainer borderleft" inputClass="input"
                                        containerStyle={{
                                            background: "inherit",
                                            width:      "auto",
                                            padding:    "0 15px"
                                        }}
                                        inputStyle={{
                                            background: "inherit",
                                            height:     "100%",
                                            width:      "100%",
                                            border:     "0px"
                                        }}
                                        buttonStyle={{
                                            background: "inherit",
                                            border:     "0px"
                                        }}
                                        dropdownStyle={{
                                            background: this.props.backgroundColor,
                                            color:      this.props.color,
                                            bottom:     "100%"
                                        }}
                                        />
                                        <div className="helpcontainer borderleft link" onClick={this.toggleHelpDisplay.bind(this)}>
                                            <div className="label pixelfont">{this.state.helpDisplayed ? <>&times;</> : "?"}</div>
                                        </div>
                                        <button id="phonesubmit" className="pixelfont" style={{backgroundColor: THEMES[this.props.theme][1], color: themeBackgroundColor}} onClick={this.registerPhone.bind(this)}>SEND</button>
                                    </div>
                                ) : (
                                    <div id="authcodeeditor">
                                        <div className="labelcontainer">
                                            <div className="label pixelfont">AUTH CODE:</div>
                                        </div>
                                        <div className="inputcontainer borderleft">
                                            <input type="text" id="authcodefield" name="authcodefield" className="input tk-acumin-pro-wide" placeholder="123456"  onChange={this.handleFieldChange.bind(this, 'authCode')} value={this.state.authCode} onKeyUp={this.registerPhone.bind(this)} />
                                        </div>
                                        <div className="helpcontainer borderleft link" onClick={this.toggleHelpDisplay.bind(this)}>
                                            <div className="label pixelfont">{this.state.helpDisplayed ? <>&times;</> : "?"}</div>
                                        </div>
                                        <button id="phonesubmit" className="pixelfont" style={{backgroundColor: THEMES[this.props.theme][1], color: themeBackgroundColor}} onClick={this.registerPhone.bind(this)}>SEND</button>
                                    </div>
                                )}</>
                            )}</>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default StreamContainer;
